import { useLayoutEffect, type RefObject } from "react";
import { etatNavigation } from "./etatNavigation.js";

/**
 * ============================================================================
 *  useObstacleBas.ts — Déclarer la place qu'un élément prend au bas de l'écran
 * ----------------------------------------------------------------------------
 *  Le titre d'arrivée se pose AU-DESSUS de ce qui occupe le bas (barre de
 *  navigation mobile, contrôleur d'ambiances). Plutôt que de recopier leurs
 *  hauteurs — zone sûre comprise, qui varie d'un téléphone à l'autre —, chacun
 *  mesure la distance entre son bord haut et le bas du conteneur de la visite,
 *  et la déclare dans `etatNavigation.bas`. Remesuré quand l'élément ou la
 *  fenêtre change de taille ; retiré au démontage ou quand `actif` tombe.
 * ==========================================================================*/

export function useObstacleBas(cle: string, element: RefObject<HTMLElement>, actif = true): void {
  useLayoutEffect(() => {
    const cible = element.current;
    if (!actif || !cible) {
      etatNavigation.setBas(cle, null);
      return;
    }
    const mesurer = () => {
      const conteneur = (cible.offsetParent as HTMLElement | null) ?? document.body;
      const hauteur = conteneur.getBoundingClientRect().bottom - cible.getBoundingClientRect().top;
      etatNavigation.setBas(cle, Math.max(0, Math.round(hauteur)));
    };
    mesurer();
    const observateur = new ResizeObserver(mesurer);
    observateur.observe(cible);
    window.addEventListener("resize", mesurer);
    return () => {
      observateur.disconnect();
      window.removeEventListener("resize", mesurer);
      etatNavigation.setBas(cle, null);
    };
  }, [cle, element, actif]);
}
